<template>
  <!-- 法律援助-申请 -->
  <div class="apply-cont">
    <h3 class="titleh3">法律援助申请须知</h3>
    <div class="apply-collapse">
      <a-collapse default-active-key="1">
        <template #expandIcon="props">
          <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
        </template>
        <a-collapse-panel
          key="1"
          header="工会法律援助的范围"
          :style="customStyle"
        >
          <ul class="applyList">
            <li>（一）劳动争议案件；</li>
            <li>
              （二）因劳动权益涉及的职工人格权、民主权、财产权等合法权益受到侵害的案件；
            </li>
            <li>（三）工会工作者因履行职责致合法权益受到侵害的案件；</li>
            <li>（四）工会组织合法权益受到侵害的案件；</li>
            <li>（五）工会认为需要提供法律援助的其他事项。</li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel
          key="2"
          header="工会法律援助的形式"
          :style="customStyle"
        >
          <ul class="applyList">
            <li>（一）普及法律知识；</li>
            <li>（二）提供法律咨询；</li>
            <li>（三）代写法律文书；</li>
            <li>（四）参与协商、调解；</li>
            <li>（五）代理仲裁、诉讼；</li>
            <li>（六）其他法律援助形式。</li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel
          key="3"
          header="工会法律援助的对象"
          :style="customStyle"
        >
          <ul class="applyList">
            <li>（一）困难职工；</li>
            <li>（二）农民工；</li>
            <li>（三）工会工作者；</li>
            <li>（四）工会组织；</li>
            <li>（五）工会认为需要提供法律援助的其他组织或个人。</li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel
          key="4"
          header="工会法律援助所称困难职工"
          :style="customStyle"
        >
          <ul class="applyList">
            <li>（一）设区市、县（市、区）总工会认定的困难职工；</li>
            <li>（二）其他经济困难确需工会提供法律援助的职工。</li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel
          key="5"
          header="工会法律援助的申请管辖"
          :style="customStyle"
        >
          <ul class="applyList">
            <li>
              （一）职工申请工会法律援助，应当向劳动合同履行地或者用人单位所在地的工会法律援助机构提出；
            </li>
            <li>
              （二）工会工作者申请法律援助，应向所在工会或上一级工会及其工会法律援助机构提出；
            </li>
            <li>
              （三）工会组织申请法律援助，应向上一级工会及其工会法律援助机构提出；
            </li>
            <li>
              （四）申请人向两个以上符合条件的工会法援助机构提出法律援助申请的，由先收到申请的工会法律援助机构受理。
            </li>
          </ul>
        </a-collapse-panel>
        <a-collapse-panel
          key="6"
          header="申请法律援助，应当提交下列材料"
          :style="customStyle"
        >
          <ul class="applyList">
            <li>（一）身份证、工作证或其他相关证件；</li>
            <li>（二）经济困难证明或其他相关证明；</li>
            <li>（三）与法律援助事项相关材料；</li>
            <li>（四）工会法律援助机构认为需要提供的其他材料。</li>
          </ul>
        </a-collapse-panel>
      </a-collapse>
      <div class="apply-btn">
        <a @click="gotoAid">申请法律援助</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LegalAidApply',
  data() {
    return {
      customStyle: '',
    };
  },
  methods: {
    gotoAid: function () {
      this.$router.push('/Aid/ApplicationGuide');
    },
  },
};
</script>
<style scoped>
.apply-cont {
  margin: 0 20px;
}
.apply-btn {
  text-align: center;
  padding: 30px 0;
}
.apply-btn a {
  display: inline-block;
  width: 200px;
  height: 52px;
  text-align: center;
  border-radius: 3px;
  background: #2b86ef;
  color: #fff;
  line-height: 52px;
  font-size: 18px;
}
.applyList li {
  list-style: none;
  line-height: 30px;
  margin-bottom: 10px;
  color: #666;
}
.apply-collapse {
  min-height: 510px;
}
.apply-collapse .ant-collapse {
  border: 0;
  background: none;
}
.apply-collapse
  /deep/
  .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header {
  color: #2b86ef;
}
.apply-collapse
  /deep/
  .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header {
  padding-left: 16px;
  background: #fafbfc;
}
.apply-collapse
  /deep/
  .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header
  .ant-collapse-arrow {
  left: inherit;
  right: 16px;
}
.apply-collapse /deep/ .ant-collapse > .ant-collapse-item {
  margin-bottom: 20px;
  border: 1px solid #d9d9d9;
}
</style>
